import Tooltip from "@mui/material/Tooltip";
import styled2 from "styled-components";
import Icon from "../../core/components/Icon.tsx";
import iconeDelete from "../../images/iconeDelete.png";
import iconeEdit from "../../images/iconeEdit.png";
import iconeSave from "../../images/iconeSave.png";
import "./CustomButtonV2.css";

const TextP = styled2.p`     
    color: ${(props) => props.corTexto};
`;

function CustomButtonV2(props) {
	return (
		<>
			{props.disabled ? (
				<Tooltip title={<p>Carregando...</p>}>
					<span>
						<button
							onClick={props.onClick}
							className="custom-button-cadastrar-gray"
							variant="contained"
							disabled={props.disabled}
						>
							{props.icone === "iconeSave" && <img src={iconeSave} />}
							{props.icone === "iconeEdit" && <img src={iconeEdit} />}
							{props.icone === "iconeDelete" && <img src={iconeDelete} />}
							{props.icone === "iconeCheck" && (
								<Icon name="Check" size="lg" theme="light" />
							)}
							<TextP corTexto={props.corTexto} className={props.classText}>
								{props.titulo}
							</TextP>
						</button>
					</span>
				</Tooltip>
			) : (
				<button
					style={{ width: props.width, marginBottom: props.marginBottom }}
					onClick={props.onClick}
					className={props.classCss}
					variant="contained"
					disabled={props.disabled}
				>
					{props.icone === "iconeSave" && <img src={iconeSave} />}
					{props.icone === "iconeEdit" && <img src={iconeEdit} />}
					{props.icone === "iconeDelete" && <img src={iconeDelete} />}
					{props.icone === "iconeCheck" && (
						<Icon name="Check" size="lg" theme="light" />
					)}
					<TextP corTexto={props.corTexto} className={props.classText}>
						{props.titulo}
					</TextP>
				</button>
			)}
		</>
	);
}

export default CustomButtonV2;
